import { NgModule, importProvidersFrom } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApiModule, Configuration, ConfigurationParameters } from '../openapi';
import { ModelViewerUrbaseeComponent } from './components/model-viewer-urbasee.component';
import { ModelViewerArtefactoModule } from '../model-viewer-artefacto/model-viewer-artefacto.module';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { DefaultPipe } from './pipes/default.pipe';
import { AuthorizationPipe } from './pipes/authorization.pipe';
import { ExtractVariantsForElementPipe } from './pipes/extract-variants-for-element.pipe';
import { I18nPipe } from './pipes/i18n.pipe';
import { ModelViewerUrbaseeInterceptor } from './interceptors/model-viewer-urbasee.interceptor';
import { FilterEnabledPipe } from './pipes/filter-enabled.pipe';
import { FilterElementEnabledPipe } from './pipes/filter-element-enabled.pipe';

export function apiConfigFactory(): Configuration {
  const params: ConfigurationParameters = {
    basePath: environment.apiUrl,
  };
  return new Configuration(params);
}

@NgModule({
  imports: [CommonModule, ModelViewerArtefactoModule, HttpClientModule],
  declarations: [
    ModelViewerUrbaseeComponent,
    AuthorizationPipe,
    ExtractVariantsForElementPipe,
    FilterEnabledPipe,
    I18nPipe,
    DefaultPipe,
    FilterElementEnabledPipe,
  ],
  providers: [
    importProvidersFrom(ApiModule.forRoot(apiConfigFactory)),
    {
      provide: HTTP_INTERCEPTORS,
      multi: true,
      useClass: ModelViewerUrbaseeInterceptor,
    },
  ],
  exports: [
    ModelViewerUrbaseeComponent,
    ExtractVariantsForElementPipe,
    I18nPipe,
    DefaultPipe,
    FilterEnabledPipe,
    FilterElementEnabledPipe,
  ],
})
export class ModelViewerUrbaseeModule {}
